//#region src/utils/mergeRefs.ts
var e = (e) => (t) => {
	e.forEach((e) => {
		typeof e == "function" ? e(t) : e && (e.current = t);
	});
};
//#endregion
export { e as default };

//# sourceMappingURL=mergeRefs.js.map